<template>
  <div class="email-us">{{$t('upgrade_page_views_static_email_us_index_2191')}}</div>
</template>
<script>
export default {
  name: 'EmailUs',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.email-us {
  width: 100vh;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 20px;
}
</style>
